import { W as WuiInputMenu$1, d as defineCustomElement$1 } from './p-ptCmZg09.js';

const WuiInputMenu = WuiInputMenu$1;
const defineCustomElement = defineCustomElement$1;

export { WuiInputMenu, defineCustomElement };
